import React from 'react';
import { videoOf } from './changelogConfig';
import styles from './Changelog.module.css';

/**
 * Imagem ou vídeo de um destaque. O vídeo (quando existe) tem prioridade e usa a imagem como capa.
 * Sem imagem nem vídeo, não renderiza nada.
 */
const ChangelogMedia = ({ entry }) => {
  const video = videoOf(entry);

  if (video) {
    return (
      <div className={styles.media}>
        <video
          className={styles.mediaVideo}
          src={video.src}
          poster={video.poster || undefined}
          controls
          preload="none"
          playsInline
        >
          {video.captions && <track kind="captions" src={video.captions} srcLang="pt-BR" label="Português" default />}
        </video>
      </div>
    );
  }

  if (!entry.image) return null;

  return (
    <div className={styles.media}>
      <img className={styles.mediaImage} src={entry.image} alt={entry.title} loading="lazy" />
    </div>
  );
};

export default ChangelogMedia;
